import { Fragment } from 'react';
import arrowLeft from '~/assets/icons/arrow_left.svg';
import { Text } from '~/components/ui/Text';
import { ToggleSound } from '~/components/ui/ToggleSound';
import { rage } from '~/rage';
import { StyledBackButton, StyledTitle } from './Head.styled';

const Head = () => {
	return (
		<Fragment>
			<StyledBackButton
				onClick={() =>
					rage.spawnSelect
						.backToCharacterSelection()
						.catch((err) => rage.notifications.showException(err))
				}
			>
				<img src={arrowLeft} />
				<Text>Вернуться назад</Text>
			</StyledBackButton>
			<StyledTitle>
				<Text>Выберите точку спавна</Text>
			</StyledTitle>
			<ToggleSound />
		</Fragment>
	);
};

export { Head };
